import {ReducerBuilder} from "@cuatroochenta/co-redux-builders";
import {PagerBackendProps} from "../../../../components/Pager";
import LogListAdminScreenActions from "./LogListCardAdminActions";
import Log from "../../../../commons/model/Log";
import TaskLogList from "../../../../commons/ws/log/TaskLogList";
import User from "../../../../commons/model/User";
import TaskLogTypeList from "../../../../commons/ws/logType/TaskLogTypeList";
import LogType from "../../../../commons/model/LogType";
import TaskUserList from "../../../../commons/ws/user/TaskUserList";

interface InitialState {
    loading: boolean,

    logs: Log[],
    logTypes: LogType[],
    error: string,
    pager: PagerBackendProps,

    usersLoading: boolean,
    users: User[],
}

const INITIAL_STATE: InitialState = {
    loading: false,
    logs: [],
    logTypes: [],
    error: '',
    pager: {
        current: 1,
        total_pages: 1,
        total_elements: 0,
    },
    usersLoading: false,
    users: [],
};

export default ReducerBuilder.newBuilder(INITIAL_STATE)

    .onEvent(TaskUserList.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState, payload) => {
        return {...oldState, usersLoading: true}
    })
    .onEvent(TaskUserList.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState, payload) => {
        return {...oldState, usersLoading: false}
    })
    .onEvent(TaskUserList.REDUX_ACTION_OBJECT_ON_FAIL, (oldState, payload) => {
        return {...oldState, error: payload}
    })
    .onEvent(TaskUserList.REDUX_ACTION_OBJECT_ON_SUCCESS, (oldState, payload) => {
        return {
            ...oldState,
            users: payload.data,
        }
    })

    .onEvent(TaskLogTypeList.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: true}
    })
    .onEvent(TaskLogTypeList.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: false}
    })
    .onEvent(TaskLogTypeList.REDUX_ACTION_OBJECT_ON_FAIL, (oldState, payload) => {
        return {...oldState, error: payload}
    })
    .onEvent(TaskLogTypeList.REDUX_ACTION_OBJECT_ON_SUCCESS, (oldState, payload) => {
        return {
            ...oldState,
            logTypes: payload.data,
        }
    })

    .onEvent(TaskLogList.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: true}
    })
    .onEvent(TaskLogList.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: false}
    })
    .onEvent(TaskLogList.REDUX_ACTION_OBJECT_ON_FAIL, (oldState, payload) => {
        return {...oldState, error: payload}
    })
    .onEvent(TaskLogList.REDUX_ACTION_OBJECT_ON_SUCCESS, (oldState, payload) => {
        return {
            ...oldState,
            logs: payload.data,
            pager: payload.pager || oldState.pager,
        }
    })

    .onEvent(LogListAdminScreenActions.clearReducer, ((oldState, payload) => INITIAL_STATE))

    .build()
